import { Inject, Renderer2 } from '@angular/core'
import { DOCUMENT } from '@angular/common'

export class StructuredDataTag {

  private id: string = ''
  private readonly script: HTMLScriptElement
  protected isServer = typeof window === 'undefined'

  constructor (
    protected identifier: string,
    protected content: any,
    protected renderer: Renderer2,
    @Inject(DOCUMENT) protected document: Document,
  ) {
    // Use identifier as ID for deterministic rendering (better caching)
    this.id = `sd-${identifier}`
    
    if (this.isServer) {
      this.script = this.renderer.createElement('script')
      this.renderer.appendChild(this.document.body, this.script)
    } else {
      this.script = document
        .querySelector(`script[data-sd-identifier="${this.identifier}"][data-sd-source="server"]`) as HTMLScriptElement
    }

    if (typeof this.document?.body?.appendChild === 'function') {
      this.script.type = 'application/ld+json'
      this.script.innerHTML = JSON.stringify(content)
      this.script.setAttribute('data-sd-source', this.isServer ? 'server' : 'client')
      this.script.setAttribute('data-sd-id', this.id)
      this.script.setAttribute('data-sd-identifier', this.identifier)
    }
  }

  update (content: any) {
    this.script.innerHTML = JSON.stringify(content)
  }

  destroy () {
    if (this.document && typeof this.document.querySelector === 'function') {
      this.renderer.removeChild(this.document.body, this.script)
    }
  }
}
